var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c("div", [
        _c(
          "div",
          { staticClass: "sections" },
          [
            _vm.withSchoolTypeSelection
              ? _c(
                  "section",
                  { staticClass: "school-type-container" },
                  [
                    _c("h3", [_vm._v("Art der Ausbildung")]),
                    _vm._v(" "),
                    _vm.schoolType
                      ? _c(
                          "div",
                          [
                            _c("Label", {
                              attrs: {
                                characteristic: _vm.schoolType[0].item,
                                "label-type": "application"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.schoolType = undefined
                                  }
                                }
                              },
                              [
                                _c("Icon", {
                                  attrs: { icon: "edit", color: "primary" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c("SelectInline", {
                          attrs: {
                            "characteristic-items": _vm.meta.schoolType,
                            "initial-show-all": "",
                            "single-choice": "",
                            "label-type": "application",
                            "description-config": { inline: true, html: true }
                          },
                          on: { input: _vm.schoolTypeChanged },
                          model: {
                            value: _vm.schoolType,
                            callback: function($$v) {
                              _vm.schoolType = $$v
                            },
                            expression: "schoolType"
                          }
                        })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.schoolType
              ? [
                  _vm.expertProfessionEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.getDynamicLabel("expertProfessionTitle")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("SelectInline", {
                            attrs: {
                              "characteristic-items":
                                _vm.meta.educationExpertProfession,
                              "single-choice": "",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.expertProfession,
                              callback: function($$v) {
                                _vm.expertProfession = $$v
                              },
                              expression: "expertProfession"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.appraiserAuthorityEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "Ist damit eine offizielle Befugnis verbunden, als Sachverständige/r tätig zu werden?"
                            )
                          ]),
                          _vm._v(" "),
                          _c("SelectInline", {
                            attrs: {
                              "characteristic-items":
                                _vm.meta.educationAppraiserAuthority,
                              "nothing-allowed": { text: "Keine" },
                              "show-multiple-hint": "",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.appraiserAuthority,
                              callback: function($$v) {
                                _vm.appraiserAuthority = $$v
                              },
                              expression: "appraiserAuthority"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.workPermissionEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v("Bitte wähle Deine Berufsberechtigung")
                          ]),
                          _vm._v(" "),
                          _c("SelectInline", {
                            attrs: {
                              "characteristic-items":
                                _vm.meta.educationWorkPermission,
                              "single-choice": "",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.workPermission,
                              callback: function($$v) {
                                _vm.workPermission = $$v
                              },
                              expression: "workPermission"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.titleEligible && _vm.titleRequired
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.getDynamicLabel("titleTitle")))
                          ]),
                          _vm._v(" "),
                          _c("b-input", {
                            attrs: {
                              type: "text",
                              placeholder: _vm.getDynamicLabel(
                                "titlePlaceholder"
                              )
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.title,
                              callback: function($$v) {
                                _vm.title = $$v
                              },
                              expression: "title"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.instituteNameRequired
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.getDynamicLabel("instituteNameTitle"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-input", {
                            attrs: { type: "text" },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.instituteName,
                              callback: function($$v) {
                                _vm.instituteName = $$v
                              },
                              expression: "instituteName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.furtherInstitutionTypeEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [_vm._v("Art des Ausbildungsinstitutes")]),
                          _vm._v(" "),
                          _c("FurtherInstitutionTypeSingleSelect", {
                            attrs: {
                              characteristics:
                                _vm.meta.educationFurtherInstitutionType,
                              "undefined-text-option-text":
                                "--- Bitte triff eine Auswahl ---",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.furtherInstitutionType,
                              callback: function($$v) {
                                _vm.furtherInstitutionType = $$v
                              },
                              expression: "furtherInstitutionType"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailsOnTop
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.getDynamicLabel("detailsTitle")) +
                                "\n\t\t\t\t\t"
                            ),
                            _vm.getDynamicLabel("detailsTooltip")
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block font-weight-normal mt-1"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.getDynamicLabel("detailsTooltip")
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("Wysiwyg", {
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.details,
                              callback: function($$v) {
                                _vm.details = $$v
                              },
                              expression: "details"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.professionEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.getDynamicLabel("professionTitle"))
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.professionsValid
                            ? _c("div", { staticClass: "error" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.getDynamicLabel("professionError")
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("CharacteristicEdit", {
                            ref: "professions",
                            staticClass: "mt-3",
                            attrs: {
                              title:
                                _vm.getDynamicLabel("professionTitleFan") ||
                                _vm.getDynamicLabel("professionTitle"),
                              "with-keyword": true,
                              "characteristic-type":
                                _vm.meta.schoolProfessionType,
                              "characteristic-items":
                                _vm.schoolProfessionMetaItems,
                              "show-multiple-hint": "",
                              "open-fan-button-alignment": "left",
                              "open-fan-label":
                                "Fachliche/n Schwerpunkt/e auswählen",
                              "open-fan-label-with-selection":
                                "Fachliche/n Schwerpunkt/e bearbeiten",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.professions,
                              callback: function($$v) {
                                _vm.professions = $$v
                              },
                              expression: "professions"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.educationCompletionEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.getDynamicLabel("educationCompletionTitle")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("SelectInline", {
                            attrs: {
                              "characteristic-items":
                                _vm.meta.educationCompletion,
                              "single-choice": "",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.educationCompletion,
                              callback: function($$v) {
                                _vm.educationCompletion = $$v
                              },
                              expression: "educationCompletion"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.educationCompletionTypeEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [_vm._v("Abschluss der Ausbildung durch")]),
                          _vm._v(" "),
                          _c("EducationCompletionTypeSingleSelect", {
                            attrs: {
                              characteristics:
                                _vm.meta.educationCompletionTypeItems,
                              "undefined-text-option-text":
                                "--- Bitte triff eine Auswahl ---",
                              "label-type": "application"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.educationCompletionType,
                              callback: function($$v) {
                                _vm.educationCompletionType = $$v
                              },
                              expression: "educationCompletionType"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gainedTitleTypeEligible
                    ? _c("section", [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.getDynamicLabel("gainedTitleTitle"))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              [
                                _c("Select", {
                                  attrs: {
                                    options: _vm.gainedTitleTypeOptions
                                  },
                                  on: { input: _vm.emitChangeEvent },
                                  model: {
                                    value: _vm.gainedTitleType,
                                    callback: function($$v) {
                                      _vm.gainedTitleType = $$v
                                    },
                                    expression: "gainedTitleType"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.gainedTitleEligible
                              ? _c(
                                  "div",
                                  { staticClass: "ml-2" },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        type: "text",
                                        placeholder:
                                          _vm.gainedTitleLabels[
                                            _vm.gainedTitleType
                                          ]
                                      },
                                      on: { input: _vm.emitChangeEvent },
                                      model: {
                                        value: _vm.gainedTitle,
                                        callback: function($$v) {
                                          _vm.gainedTitle = $$v
                                        },
                                        expression: "gainedTitle"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.scopeCountriesEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [_vm._v("Geltungsbereich")]),
                          _vm._v(" "),
                          _c("ScopeCountryMultiSelect", {
                            attrs: {
                              meta: _vm.meta,
                              "initial-nothing":
                                _vm.scopeCountriesInitialWorldwide,
                              "nothing-eligible": "",
                              "nothing-text": "Unbeschränkt"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.scopeCountries,
                              callback: function($$v) {
                                _vm.scopeCountries = $$v
                              },
                              expression: "scopeCountries"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.studyEntitlementEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.getDynamicLabel("studyEntitlementTitle")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("RadioGroup", {
                            attrs: { options: _vm.yesNoOptions },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.studyEntitlement,
                              callback: function($$v) {
                                _vm.studyEntitlement = $$v
                              },
                              expression: "studyEntitlement"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.postgraduateEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "Ist das eine postgraduale Ausbildung, wie MBA, LL.M., PhD oder Doktorat?"
                            )
                          ]),
                          _vm._v(" "),
                          _c("RadioGroup", {
                            attrs: { options: _vm.yesNoOptions },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.postgraduate,
                              callback: function($$v) {
                                _vm.postgraduate = $$v
                              },
                              expression: "postgraduate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.validityEligible
                    ? _c(
                        "section",
                        [
                          _c("h3", [
                            _vm._v(
                              "Gültigkeitsdauer - wie lange gilt die Ausbildung?"
                            )
                          ]),
                          _vm._v(" "),
                          _c("ValidityDateSelect", {
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.validityDate,
                              callback: function($$v) {
                                _vm.validityDate = $$v
                              },
                              expression: "validityDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.withDetails && _vm.schoolType
          ? _c("div", { staticClass: "mt-5" }, [
              _c("h3", [_vm._v("Details zur Ausbildung")]),
              _vm._v(" "),
              _c("div", { staticClass: "sections mt-4" }, [
                _c(
                  "section",
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.getDynamicLabel("startEndTitle")))
                    ]),
                    _vm._v(" "),
                    _c("DateEdit", {
                      attrs: { "show-required-error": false },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.startEnd,
                        callback: function($$v) {
                          _vm.startEnd = $$v
                        },
                        expression: "startEnd"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.titleEligible && !_vm.titleRequired
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.getDynamicLabel("titleTitle")))
                        ]),
                        _vm._v(" "),
                        _c("b-input", {
                          attrs: {
                            type: "text",
                            placeholder: _vm.getDynamicLabel("titlePlaceholder")
                          },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.title,
                            callback: function($$v) {
                              _vm.title = $$v
                            },
                            expression: "title"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.instituteNameRequired
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.getDynamicLabel("instituteNameTitle"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-input", {
                          attrs: { type: "text" },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.instituteName,
                            callback: function($$v) {
                              _vm.instituteName = $$v
                            },
                            expression: "instituteName"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.detailsOnTop
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.getDynamicLabel("detailsTitle")) +
                              "\n\t\t\t\t\t"
                          ),
                          _vm.getDynamicLabel("detailsTooltip")
                            ? _c(
                                "span",
                                {
                                  staticClass: "d-block font-weight-normal mt-1"
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.getDynamicLabel("detailsTooltip")
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("Wysiwyg", {
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.details,
                            callback: function($$v) {
                              _vm.details = $$v
                            },
                            expression: "details"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.schoolLocationEligible
                  ? _c(
                      "section",
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.getDynamicLabel("schoolLocationTitle"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("CharacteristicEdit", {
                          attrs: {
                            title: _vm.getDynamicLabel("schoolLocationTitle"),
                            "sub-title": _vm.getDynamicLabel(
                              "schoolLocationSubTitle"
                            ),
                            "with-keyword": true,
                            "characteristic-type": _vm.meta.geoType,
                            "characteristic-items": _vm.schoolLocationMetaItems,
                            "open-fan-label": "Ort/e auswählen",
                            "open-fan-label-with-selection": "Ort/e bearbeiten",
                            "open-fan-button-alignment": "left",
                            "label-type": "application"
                          },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.schoolLocation,
                            callback: function($$v) {
                              _vm.schoolLocation = $$v
                            },
                            expression: "schoolLocation"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }